import { render, staticRenderFns } from "./importUser.vue?vue&type=template&id=0aa23eb3&scoped=true&"
import script from "./importUser.vue?vue&type=script&lang=js&"
export * from "./importUser.vue?vue&type=script&lang=js&"
import style0 from "./importUser.vue?vue&type=style&index=0&id=0aa23eb3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa23eb3",
  null
  
)

export default component.exports